var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgSocialMedia1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7065 13.5683C25.7065 7.317 20.6703 2.25 14.4565 2.25C8.24279 2.25 3.20654 7.317 3.20654 13.5683C3.20654 19.2188 7.31954 23.901 12.6985 24.75V16.8405H9.84254V13.5675H12.6985V11.0745C12.6985 8.238 14.3778 6.6705 16.948 6.6705C18.178 6.6705 19.4665 6.89175 19.4665 6.89175V9.67725H18.0468C16.6495 9.67725 16.2145 10.5503 16.2145 11.4458V13.5683H19.3345L18.8358 16.8398H16.2145V24.75C21.5935 23.901 25.7065 19.2188 25.7065 13.5683Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMedia1);
export default __webpack_public_path__ + "static/media/Social Media1.bbc42783a6c9e94e52636247e9552944.svg";
export { ForwardRef as ReactComponent };